import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { useStaticData } from '@mc/static-data-react'
import { StickyFooter } from 'components/StickyFooter'
import { CourseMeta, OutcomeContent } from 'types/data'
import { useOutcomePageEvents } from '../utils'
import { CategoryBreadcrumbBar } from './CategoryBreadcrumbBar'
import { ContentListHeading } from './ContentListHeading'
import { Hero } from './Hero'
import { OutcomeContentList } from './OutcomeContentList'
import { useVideoContext, VideoContextProps } from './VideoContext'

const BelowTheFold = dynamic(
  () => import('./BelowTheFold').then((m) => m.BelowTheFold),
  { ssr: false },
)

const TrailerVideoModal = dynamic(
  () => import('./TrailerVideoModal').then((m) => m.TrailerVideoModal),
  {
    ssr: false,
  },
)

const PageContent = React.memo(() => {
  const { outcomeRankedContent, courseSlugToMeta } = useStaticData<{
    courseSlugToMeta: Record<string, CourseMeta>
    outcomeRankedContent: OutcomeContent[]
  }>()
  const { trackProductListViewed } = useOutcomePageEvents()

  useEffect(() => {
    trackProductListViewed()
  }, [trackProductListViewed])

  return (
    <div>
      <CategoryBreadcrumbBar />
      <Hero />
      <ContentListHeading />
      <OutcomeContentList
        content={outcomeRankedContent.slice(0, 3)}
        courseMeta={courseSlugToMeta}
        isPrioritized
      />
      <BelowTheFold />
      <StickyFooter />
    </div>
  )
})
PageContent.displayName = 'PageContent'

export const OutcomePage = () => {
  const { isModalOpen, courseMetaForVideo, closeVideo } =
    useVideoContext<VideoContextProps>()

  return (
    <>
      <PageContent />
      {isModalOpen && courseMetaForVideo && (
        <TrailerVideoModal
          isModalOpen={isModalOpen}
          courseMeta={courseMetaForVideo}
          closeVideo={closeVideo}
        />
      )}
    </>
  )
}
